import React, { useState, useEffect } from "react";
import { useUser } from "../../Context/UserContext"; // Usamos el contexto del usuario
import { FaUserCircle, FaShoppingCart, FaBars, FaTimes, FaMicrochip, FaCog } from "react-icons/fa"; // Import icons for hamburger and close
import "./HeaderServices.css";
import { useNavigate } from "react-router-dom";

const HeaderServices = () => {
  const [click, setClick] = useState(false); // State to toggle sidebar
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar si estamos cargando la sesión
  const navigate = useNavigate(); // Hook de navegación

  const { user, setUser } = useUser(); // Obtenemos el usuario del contexto

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false); // Una vez que termine la carga, actualizamos isLoading
  }, [setUser]);

  const handleClick = () => setClick(!click); // Toggle sidebar
  const closeMenu = () => setClick(false); // Close sidebar

  const handleLogout = () => {
    setUser(null); // Limpiar el usuario del contexto al hacer logout
    localStorage.removeItem("user"); // Limpiar el usuario del localStorage
    navigate("/");
  };

  if (isLoading) {
    return <div className="services-loading">Cargando servicios...</div>; // Loading específico para services
  }

  return (
    <div className="header-services-container">
      <nav className="navbar-services-container">
        {/* Logo */}
        <div className="logo-services-container">
          <span className="logo-services-wrapper">
            <a href="/" className="logo-services">
              <img
                src="/images/logo_Services.png"
                alt="Logo Volteon Services"
                className="logo-services-img"
              />
              <div className="services-badge">
                <FaMicrochip className="services-icon" />
                <span className="services-text">SERVICES</span>
              </div>
            </a>
          </span>
        </div>

        {/* Hamburger Menu Icon (Mobile Only) */}
        <div className="mobile-menu-services-icon" onClick={handleClick}>
          {click ? <FaTimes className="icon" /> : <FaBars className="icon" />}
        </div>

        {/* Regular Menu (Desktop) */}
        <ul className="nav-menu-services-container">
          <li className="nav-services-item">
            <a href="/" onClick={closeMenu}>
              <span className="nav-text">Inicio</span>
              <div className="nav-underline"></div>
            </a>
          </li>
          <li className="nav-services-item">
            <a href="/servicios/PCB" onClick={closeMenu}>
              <span className="nav-text">Diseño PCB</span>
              <div className="nav-underline"></div>
            </a>
          </li>
          <li className="nav-services-item">
            <a href="/kits" onClick={closeMenu}>
              <span className="nav-text">Kits</span>
              <div className="nav-underline"></div>
            </a>
          </li>
          <li className="nav-services-item">
            <a href="/insignia" onClick={closeMenu}>
              <span className="nav-text">Productos Insignia</span>
              <div className="nav-underline"></div>
            </a>
          </li>
          <li className="nav-services-item">
            <a href="/catalogo" onClick={closeMenu}>
              <span className="nav-text">Catálogo</span>
              <div className="nav-underline"></div>
            </a>
          </li>

          {user ? (
              <>
                <li className="nav-services-item">
                  <a href="/perfil" className="user-name-services">
                    <FaUserCircle className="user-icon" />
                    {user.name.split(" ").slice(0, 2).join(" ")}
                  </a>
                </li>
                <button
                    className="btn-services-container logout-btn-services"
                    onClick={handleLogout}
                >
                  <FaCog className="btn-icon" />
                  Cerrar sesión
                </button>
              </>
          ) : (
              <>
                <a
                    href="/iniciar-sesion"
                    className="btn-services-container login-btn-services"
                >
                  Iniciar sesión
                </a>
                <a
                    href="/crear-cuenta"
                    className="btn-services-container signup-btn-services"
                >
                  <FaMicrochip className="btn-icon" />
                  Crear cuenta
                </a>
              </>
          )}
        </ul>

        {/* Sidebar para móvil */}
        <div className={`sidebar-services ${click ? "active" : ""}`}>
          <div className="sidebar-services-content">
            <ul className="nav-menu-services-mobile">
              <li className="nav-services-item-mobile">
                <a href="/" onClick={closeMenu}>
                  Inicio
                </a>
              </li>
              <li className="nav-services-item-mobile">
                <a href="/servicios/PCB" onClick={closeMenu}>
                  Diseño PCB
                </a>
              </li>
              <li className="nav-services-item-mobile">
                <a href="/kits" onClick={closeMenu}>
                  Kits
                </a>
              </li>
              <li className="nav-services-item-mobile">
                <a href="/insignia" onClick={closeMenu}>
                  Productos Insignia
                </a>
              </li>
              <li className="nav-services-item-mobile">
                <a href="/catalogo" onClick={closeMenu}>
                  Catálogo
                </a>
              </li>

              {user ? (
                  <>
                    <li className="nav-services-item-mobile">
                      <a href="/perfil" className="user-name-services-mobile">
                        <FaUserCircle className="user-icon" />
                        {user.name.split(" ").slice(0, 2).join(" ")}
                      </a>
                    </li>
                    <button
                        className="btn-services-container-mobile logout-btn-services"
                        onClick={handleLogout}
                    >
                      Cerrar sesión
                    </button>
                  </>
              ) : (
                  <>
                    <li className="nav-services-item-mobile">
                      <a
                          href="/iniciar-sesion"
                          className="btn-services-container-mobile login-btn-services"
                      >
                        Iniciar sesión
                      </a>
                    </li>
                    <li className="nav-services-item-mobile">
                      <a
                          href="/crear-cuenta"
                          className="btn-services-container-mobile signup-btn-services"
                      >
                        Crear cuenta
                      </a>
                    </li>
                  </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default HeaderServices;